import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-media")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-media")),
  head: () => ({
    meta: [{ title: "Admin · Ambassador Media — Lecmo" }, { name: "robots", content: "noindex, nofollow" }],
  }),
});
